module.exports = __webpack_public_path__ + "assets/img/search_3.6389219b.png";